import React from 'react';
import ChartBox from '../../Custom/ChartBox';
import PieChartSiteConsumption from '../LCReports/PieChartSiteConsumption';

const SiteConsumption = ({ data }) => (
  <div height="100px">
    <ChartBox title={'Site Consumption'}>
      <PieChartSiteConsumption data={data} />
    </ChartBox>
  </div>
);

export default SiteConsumption;
